export enum ActionType {
  CHANGE_PASSWORD = "action/CHANGE_PASSWORD",
  CHANGE_PASSWORD_SUCCESS = "action/CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_ERROR = "action/CHANGE_PASSWORD_ERROR",
  RESET_CHANGE_PASSWORD = "action/RESET_CHANGE_PASSWORD",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ChangePasswordData {
  current_password: any;
  new_password: any;
  confirm_new_password: any;
}
